// angular import
import { Component } from '@angular/core';
import { IconProp } from '@fortawesome/angular-fontawesome/types';
import { faBell, faCircleUser } from '@fortawesome/free-solid-svg-icons';
import { KeycloakService } from 'keycloak-angular';
import { forkJoin, map } from 'rxjs';
import { ruoli } from 'src/app/shared/data/ruoli';
import { UserKeycloak } from 'src/app/shared/model/user.keycloak';
import { BetterService } from 'src/app/shared/services/better.service';

@Component({
  selector: 'app-nav-right',
  templateUrl: './toolbar-right.component.html',
  styleUrls: ['./toolbar-right.component.scss']
})
export class NavRightComponent {
  // public props
  mainCards = [
   
  ];

  userProfile:UserKeycloak|undefined;
  faUser: IconProp=faCircleUser;
  listaTotale: any[]=[];
  faNotification: IconProp=faBell;
  // Constructor
  constructor(private keycloakService: KeycloakService,private betterService: BetterService) {
   

  }
  async ngOnInit(){
    const ruoliKey=await this.keycloakService.getUserRoles()
    this.userProfile={
    profile:await this.keycloakService.loadUserProfile(),
    role:ruoliKey,
    ruoloGenomica:ruoliKey.filter(r=>ruoli.includes(r))[0]
   }
  }
  getGeneTotal() {

    forkJoin([
      this.betterService.getAllRichieste().pipe(
        map(res => res.map(ele => ({ ...ele, sequenza: 'sequenziamento' })))
      ),
      this.betterService.getAllRichiesteCariotipo().pipe(
        map(res => res.map(ele => ({ ...ele, sequenza: 'cariotipo' })))
      )
    ]).pipe(
      map(([richieste, cariotipo]) => {
        // Unisce le due liste e le ordina per la proprietà `maxdata`
        const combinedList = [...richieste, ...cariotipo];
        return combinedList.sort((a, b) => new Date(b.maxdata).getTime() - new Date(a.maxdata).getTime());
      })
    ).subscribe(sortedList => {

      this.listaTotale = sortedList.sort((a, b) => new Date(b.maxdata).getTime() - new Date(a.maxdata).getTime());
    });
  }
}
